import { render } from "./RegionsPage.vue?vue&type=template&id=502a68d7&scoped=true"
import script from "./RegionsPage.vue?vue&type=script&lang=js"
export * from "./RegionsPage.vue?vue&type=script&lang=js"

import "./RegionsPage.vue?vue&type=style&index=0&id=502a68d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-502a68d7"]])

export default __exports__